const trademarkSymbols = [
    {
        pattern: '%TM%',
        replacement: '<sup>TM</sup>',
    },
    {
        pattern: '%REG%',
        replacement: '<sup>®</sup>',
    },
    {
        pattern: '%COPY%',
        replacement: '<sup>©</sup>',
    },
    {
        pattern: '%SM%',
        replacement: '<sup>SM</sup>',
    },
    {
        pattern: '%MC%',
        replacement: '<sup>MC</sup>',
    },
    {
        pattern: '%MD%',
        replacement: '<sup>MD</sup>',
    },
];

export class TrademarkSymbolUtil {
    constructor() {
        throw new Error('This class cannot be instantiated');
    }
    static replaceTrademarks(content: string): string {
        let modifiedContent = content;
        trademarkSymbols.forEach(symbol => {
            const regex = new RegExp(symbol.pattern, 'g');
            modifiedContent = modifiedContent.replace(
                regex,
                symbol.replacement
            );
        });
        return modifiedContent;
    }
}

export default TrademarkSymbolUtil;
